import { LogicGroup } from "./jsonlogic/logic-group";

export class FormDeterminant {
  public id: string;
  public key: string;
  public jsonDeterminant: LogicGroup[] = [new LogicGroup()];
  public jsonLogic: any;
  public value: boolean = true;
}
